<div class="card json-container flex-1">
  <div *ngIf="tileInstance">
    <h4>
      <mat-icon style="flex: 0 0 auto">filter_alt</mat-icon>Filters Channel '{{
        filtersChannel?.channelName
      }}'
    </h4>
    <p class="json-tag">
      {{ filtersJson }}
    </p>
  </div>
</div>
